import { EN_ALPHABET, EN_WORDS, EN_YILAN_WORDS } from "./english-words";
import { TR_ALPHABET, WORDS, YILAN_WORDS, trUpper } from "./turkish-words";

/**
 * The word games' language: the player's language picks the lexicon (Türkçe oyuncu Türkçe, English player
 * English words). Pure data, no DOM: cores take it as a parameter, scenes pass `currentLang()`.
 */
export type WordLang = "tr" | "en";

export interface Lexicon {
  lang: WordLang;
  alphabet: string;
  /** Vowels of the alphabet (letter-stream balancing). */
  vowels: string;
  /** Everyday words, 3–6 letters, uppercase. */
  words: readonly string[];
  /** `words` plus a long-word layer (up to 14 letters) for Harf Yılanı. */
  yilanWords: readonly string[];
  upper(s: string): string;
}

export const LEXICONS: Readonly<Record<WordLang, Lexicon>> = {
  tr: { lang: "tr", alphabet: TR_ALPHABET, vowels: "AEIİOÖUÜ", words: WORDS, yilanWords: YILAN_WORDS, upper: trUpper },
  en: { lang: "en", alphabet: EN_ALPHABET, vowels: "AEIOU", words: EN_WORDS, yilanWords: EN_YILAN_WORDS, upper: (s) => s.toUpperCase() },
};

export function lexicon(lang: WordLang = "tr"): Lexicon {
  return LEXICONS[lang] ?? LEXICONS.tr;
}
